'use strict';

var clamp = require('../../../../../../motion-utils/dist/es/clamp.cjs');

const number = {
    test: (v) => typeof v === "number",
    parse: parseFloat,
    transform: (v) => v,
};
const alpha = {
    ...number,
    transform: (v) => clamp.clamp(0, 1, v),
};
const scale = {
    ...number,
    default: 1,
};

exports.alpha = alpha;
exports.number = number;
exports.scale = scale;
//# sourceMappingURL=index.cjs.map
